import React, { useState } from "react";
import Switch from "@mui/material/Switch";
//import makeStyles from '@mui/style/makeStyles';
//import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";
import DropdownTablewidget from "./DropdownTablewidget";
import Tablewidgetrealtimehistoricalrealtime from "./Tablewidgetrealtimehistoricalrealtime";
import Tablewidget from "./Tablewidget";

export default function SwitchTablerealhist(props){

    const[energyconsumersaver, setStateVarConsumerSaver] = useState(true)
    const[selectedVal, setSelectedValue] = useState("Realtime")
    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
        width: "100px",
        height: "28px",
        padding: "0px",
        justifyContent:"center",
        '& .MuiSwitch-switchBase': {
              color: "#B5BFBC",
              padding: "0px",
              justifyContent:"center",
              '&.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: "#005C8E",      
              },
         },
        '& .MuiSwitch-thumb': {
              color: "#E0E0E0",
              width: "20px",
              height: "20px",
              margin: "4px 5px 4px 5px",
              padding:"0px"
        },
        '& .MuiSwitch-track': {
              borderRadius: "20px",
              backgroundColor:"#005C8E",
              justifyContent:"center",
              opacity: "1 !important",
              '&:after': {
                color: "#E0E0E0",
                fontSize: "11px",
                position: "relative",
                marginLeft:"45px",
                marginTop:"10px",
                paddingTop:"10px",
                content:(energyconsumersaver==false)?'"Historical"':'""'
            },
      
        },
        '& .Mui-checked': {
            color: "#005C8E",
            transform: "translateX(19px) !important",
            transitionDuration: '4s',
            transitionDelay:'10s',
            '&: before': {
              color: "#E0E0E0",
              fontSize: "11px",
              position: "relative",
              marginBottom:"2px",
              content:'"Realtime"'
          },
           
        },
      }));

    function handleChangeEnergyCostBudget(event){
        
        if(energyconsumersaver == false){
            setSelectedValue("Realtime")
            setStateVarConsumerSaver(!energyconsumersaver);
        }else{
            setSelectedValue("Historical")
            setStateVarConsumerSaver(!energyconsumersaver);
        }
       
    };

    return(<>
        <div style={{borderRadius:"20px"}}>
            <div style={{display: 'flex', marginRight: '20px', marginTop: '20px'}}>
                <div style={{flexGrow: 1}}></div>
                <MaterialUISwitch
                    checked={energyconsumersaver}
                    onChange={handleChangeEnergyCostBudget}
                    name="Name"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                />
            </div>
            
            {(selectedVal === "Realtime") && <Tablewidgetrealtimehistoricalrealtime widgetprop={props.widgetprop} selectedValue={selectedVal}/>}
            {(selectedVal === "Historical") && <Tablewidget widgetprop={props.widgetprop} selectedValue={selectedVal}/>}

            <DropdownTablewidget widgetprop={props.widgetprop} selectedValue={selectedVal}/>                           
        </div>
    </>)
}